import React from "react";
import { MeetingsSidePanelAttendees } from "./MeetingsSidePanelAttendees";
import MeetingsTile from "./MeetingsTile";
import { labelledParticipant } from "./models";

type MeetingsSidePanelProps = {
  data: {
    title: string;
    eventsId: number;
    assessmentType: string;
    startDate: Date;
    participants: labelledParticipant[];
    assessmentProngIdList: string[];
    assessmentName: string;
    hasBookedCandidates: boolean;
  };
};

export const MeetingsSidePanel: React.FC<MeetingsSidePanelProps> = ({
  data,
}) => {
  const candidates = data.participants.filter(
    ({ type }) => type === "CANDIDATE"
  );

  const candidatesData = candidates
    .map(({ name, assessmentProngId }) => {
      return {
        name,
        assessmentProngId: assessmentProngId ? assessmentProngId : null,
      };
    })
    .filter(item => item !== null);

  const candidatesNames = candidates.map(({ name }) => name);

  return (
    <div className="MeetingsSidePanel WidthContent">
      <div className="MeetingsSidePanel__tile">
        <MeetingsTile
          eventsId={data.eventsId}
          assessmentType={data.assessmentType}
          jobTitle={data.title}
          variant="LARGE"
          startDate={data.startDate}
          assessmentProngIdList={data.assessmentProngIdList}
          candidatesData={candidatesData}
          hasBookedCandidates={data.hasBookedCandidates}
        />
      </div>
      <div className="MeetingsSidePanel__attendeesWrapper">
        <div className="MeetingsSidePanel__attendeesTitle">
          Meeting Attendees
        </div>

        <MeetingsSidePanelAttendees
          title="Candidates"
          attendees={candidatesNames}
        />
        <MeetingsSidePanelAttendees
          title="Other assessors"
          attendees={data.participants
            .filter(({ type }) => type === "ASSESSOR")
            .map(({ name }) => name)}
        />
      </div>
    </div>
  );
};
